import { Button as UnstyledButton } from '@rocketlane/ui';
import styled from 'styled-components';
import { Menu } from '../../atoms/dropdown';
import { Tag as TagAtom } from '../../atoms/tag';
import { ActionBar } from '../action-bar';

const Tag = styled(TagAtom)``;
const FilterBarComponent = styled(ActionBar)`
  --action-bar-background: var(--white-100);
  margin: 0;
  padding: var(--spacing-05) var(--left-spacing);
  /* box-shadow: var(--shadow-02); */
  position: relative;
  z-index: var(--zindex-elevated);
  & ${Tag} {
    margin-left: var(--spacing-03);
  }
`;

const Button = styled(UnstyledButton).attrs({
  variant: 'link',
  size: 'small',
})`
  margin-right: var(--spacing-03);

  &:last-child {
    margin-right: 0;
  }
`;

const Label = styled.span`
  font-weight: var(--font-weight-bold);
  padding: var(--spacing-02) var(--spacing-05);
  display: inline-block;
  margin-right: var(--spacing-03);

  &:last-child {
    margin-right: 0;
  }
`;

type FilterBar = typeof FilterBarComponent & {
  Pill: typeof Tag;
  Button: typeof Button;
  Label: typeof Label;
  Menu: typeof Menu;
  Primary: typeof ActionBar.Primary;
  Secondary: typeof ActionBar.Secondary;
  Central: typeof ActionBar.Central;
};

const FilterBar: FilterBar = FilterBarComponent as any;

FilterBar.Pill = Tag;
FilterBar.Menu = Menu;
FilterBar.Button = Button;
FilterBar.Label = Label;

export { FilterBar };
